import { render, staticRenderFns } from "./course_zone.vue?vue&type=template&id=f2b4860a&scoped=true"
import script from "./course_zone.vue?vue&type=script&lang=js"
export * from "./course_zone.vue?vue&type=script&lang=js"
import style0 from "./course_zone.vue?vue&type=style&index=0&id=f2b4860a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b4860a",
  null
  
)

export default component.exports